module.exports = __webpack_public_path__ + "img/page-5-line-water@3x.9419971f.png";